import { render, staticRenderFns } from "./pipe-email-confirm.vue?vue&type=template&id=03b12544&scoped=true"
import script from "./pipe-email-confirm.vue?vue&type=script&lang=js"
export * from "./pipe-email-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b12544",
  null
  
)

export default component.exports